module.exports = __webpack_public_path__ + "img/A2.73235b83.jpg";